import{V as s,p as i}from"./vue-class-component.esm-bundler.js";class Props{constructor(){this.loading=i({type:Boolean,default:!1})}}class LoadingMixin extends(s.with(Props)){created(){this.isLoadingMixin=!0}}export{LoadingMixin as L};
//# sourceMappingURL=LoadingMixin.js.map
